import React, { useState, useEffect } from "react";
import MonacoEditor from 'react-monaco-editor';
import axios from "axios";
import ReactSwitchsupport from 'react-switch'
import Select from 'react-select';
import ReactPlayer from 'react-player'
import Modal from '../Modal/Modal';
import { isPro, debugMode, getNonce, getNoticeData, admin_list } from '../../Helpers';
import orderStatus from '../../../assets/order-status.gif'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css'
import NoticeModal from '../NoticeModal/NoticeModal';
import './emengency.scss'

const Emengency = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [credentials, setCredentials] = useState([]);
    const [debugLog, setDebugLog] = useState(debugMode());
    const proData = isPro();
    const allConditionsMet = proData;
    const adminList = admin_list();
    const options = JSON.parse(adminList);

    const customFilterOption = (option, searchText) => {
        return option.label.toLowerCase().startsWith(searchText.toLowerCase());
    };

    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        type: 'confirmation',
        title: '',
        message: '',
        onConfirm: () => { },
        confirmText: 'Confirm',
        declineText: 'Cancel'
    });

    const closeModal = () => {
        setModalConfig(prev => ({ ...prev, isOpen: false }));
    };


    // Extract the last part of the URL as the site identifier
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const indexOfAdmin = pathParts.indexOf('wp-admin');
    const siteIdentifier = indexOfAdmin !== -1 ? pathParts.slice(indexOfAdmin - 1, indexOfAdmin).pop() : pathParts.slice(-1).pop();
    // Use the site identifier to create a unique localStorage key
    const localStorageKey = `wpnts_Emengency_settings_${siteIdentifier}`;
    //END ------------------


    useEffect(() => {
        getWebhook();
    }, []);


    function getWebhook() {
        const wpnts_emengency_shutdown_settings = getNoticeData().wpnts_schedules_interval_debuglog_settings || {
            webhook: "",
        };

        const formData = JSON.parse(localStorage.getItem(localStorageKey) || JSON.stringify(wpnts_emengency_shutdown_settings));
        setCredentials(formData);
    }


    const [wpntswebhook_emengency_shutdown, setWebhook] = useState({
        start_emengency_shutdown: credentials.start_emengency_shutdown,
        emengency_shutdown_mode: credentials.emengency_shutdown_mode,
        selected_super_admin: credentials.selected_super_admin,

    });

    const handleEmengencyshutdownMode = e => {
        if (!allConditionsMet) {
            // setModalOpen(true)
            setModalConfig({
                isOpen: true,
                type: 'premium',
                title: '� Oops! This is a Premium Feature ',
                message: 'Evaluate the features and select a bundle based on your needs.',
                onConfirm: () => {
                    window.open('https://functiondeck.com/pricing/', '_blank');
                    closeModal();
                },
                confirmText: 'Upgrade Now',
                declineText: 'Maybe Later'
            });
            return;
        }

        setWebhook(prev => ({ ...prev, emengency_shutdown_mode: e }));
    }

    const handleSuperadmin = e => {
        if (!allConditionsMet) {
            setModalConfig({
                isOpen: true,
                type: 'premium',
                title: '� Oops! This is a Premium Feature ',
                message: 'Evaluate the features and select a bundle based on your needs.',
                onConfirm: () => {
                    window.open('https://functiondeck.com/pricing/', '_blank');
                    closeModal();
                },
                confirmText: 'Upgrade Now',
                declineText: 'Maybe Later'
            });
            return;
        }

        setWebhook(prev => ({ ...prev, selected_super_admin: e }));
    }

    const handleEmengencyShutdown = e => {
        if (!allConditionsMet) {

            setModalConfig({
                isOpen: true,
                type: 'premium',
                title: '� Oops! This is a Premium Feature ',
                message: 'Evaluate the features and select a bundle based on your needs.',
                onConfirm: () => {
                    window.open('https://functiondeck.com/pricing/', '_blank');
                    closeModal();
                },
                confirmText: 'Upgrade Now',
                declineText: 'Maybe Later'
            });
            return;
        }

        setWebhook(prev => ({ ...prev, start_emengency_shutdown: e }));
    }



    useEffect(() => {
        setWebhook({
            start_emengency_shutdown: credentials.start_emengency_shutdown,
            emengency_shutdown_mode: credentials.emengency_shutdown_mode,
            selected_super_admin: credentials.selected_super_admin,
        });
    }, [credentials]);


    const handleSave = async e => {
        e.preventDefault()

        if (!allConditionsMet) {
            // setModalOpen(true)
            setModalConfig({
                isOpen: true,
                type: 'premium',
                title: '� Oops! This is a Premium Feature ',
                message: 'Evaluate the features and select a bundle based on your needs.',
                onConfirm: () => {
                    window.open('https://functiondeck.com/pricing/', '_blank');
                    closeModal();
                },
                confirmText: 'Upgrade Now',
                declineText: 'Maybe Later'
            });
            return;
        }

        localStorage.setItem(localStorageKey, JSON.stringify(wpntswebhook_emengency_shutdown));


        /**
         * Add new plugin list name 
         * 
         */
        const url = `${appLocalizer.wpntsUrl}/wpnts/v1/slack_webhook_wpntswebhook_emengency_shutdown`;
        try {
            const res = await axios.post(url, {
                wpntswebhook_emengency_shutdown

            }, {
                headers: {
                    'content-type': 'application/json',
                    'X-WP-NONCE': appLocalizer.nonce
                }
            }).then(function (res) {
            });

        } catch (err) {
            console.log(err);
        }


        setModalConfig({
            isOpen: true,
            type: 'toast',
            title: 'success!',
            message: 'Updated',
            position: 'top-right'
        });
        setTimeout(closeModal, 3000);

    }



    return (
        <div className="acb_emengency_shutdown" id='acb_emengency_shutdown'>
            <div className="acb_left">
                <h3 className="esp-video">Emengency Shutdown panel
                    <a href="https://www.youtube.com/playlist?list=PL4m92NgWQaq5ttBH9gSYUX1r4c6rtgLg9" target="_blank"><PlayCircleIcon className='PlayCircleIcon' /></a>
                </h3>

                <br />
                <div className="wpnts-active-emengency-shutdown-mode">
                    {!allConditionsMet ? <p className="PRO_TAG">PRO</p> : ''}
                    {/* <p className="NEW_TAGs">New</p> */}
                    <div className={`emengency_shutdown_mode_panel wpnts_ispro ${allConditionsMet ? '' : 'inactive'}`}>
                        <ReactSwitchsupport uncheckedIcon checkedIcon className="emengency-supportSwitch-2" name="wpnts-switch-p-activation" id="emengency_shutdown_mode" onChange={handleEmengencyshutdownMode} checked={wpntswebhook_emengency_shutdown.emengency_shutdown_mode} height={20} width={40} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" />
                        <label htmlFor="emengency_shutdown_mode">Emengency shutdown mode:</label>
                        <Tippy content="This advanced feature allows super admin to log out all users from the website at once. Once the 'Emergency Shutdown' is activated, everyone except super admins will be logged out instantly and won't be able to log back in until it's turned off.">
                            <span className="wcs_title"><HelpOutlineIcon className='wcs_tooltip_icon' /></span>
                        </Tippy>
                    </div>
                </div>

                <div className="wpnts-active-emergency-shutdown-mode">
                    {!allConditionsMet ? <p className="pro-tag">PRO</p> : ''}
                    <p className="upcoming-tag">Upcoming</p>

                    <div className={`emergency_shutdown_mode_panel wpnts_ispro ${allConditionsMet ? '' : 'inactive'} disabled`}>
                        <ReactSwitchsupport
                            uncheckedIcon
                            checkedIcon
                            className="emergency-supportSwitch-2"
                            height={20}
                            width={40}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            disabled={true}
                        />
                        <label htmlFor="emergency_shutdown_mode">Remotely activate emergency shutdown mode:</label>
                        <Tippy content="This advanced feature allows super admins to remotely activate the emergency shutdown mode without logging into the site. When an admin receives alerts via Slack/email indicating potential hack attempts, they can instantly activate this protection remotely using secure keys.">
                            <span className="wcs_title"><HelpOutlineIcon className='wcs_tooltip_icon' /></span>
                        </Tippy>
                    </div>
                </div>

                <div className="start_emengency_shutdown">
                    <form action="" id="wpnts_emengency_shutdown_settings" className={`wpnts_ispro ${allConditionsMet ? '' : 'inactive'}`}>
                        {wpntswebhook_emengency_shutdown.emengency_shutdown_mode ?
                            <div className="shutdownmode">

                                <div className={`formInput`}>

                                    <label htmlFor="users">Select Super Admin:</label>
                                    <Select
                                        id="users"
                                        options={options}
                                        isMulti
                                        value={wpntswebhook_emengency_shutdown.selected_super_admin}
                                        onChange={handleSuperadmin}
                                        filterOption={customFilterOption}
                                        placeholder="Search users..."
                                    />
                                </div>

                                <div className="formInput start_emengency_shutdown">
                                    <ReactSwitchsupport uncheckedIcon checkedIcon className="emengency-supportSwitch-2" name="wpnts-switch-p-activation" id="start_emengency_shutdown" onChange={handleEmengencyShutdown} checked={wpntswebhook_emengency_shutdown.start_emengency_shutdown} height={20} width={40} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" />
                                    <label htmlFor="start_emengency_shutdown">Start emengency shutdown: </label>
                                    <Tippy content="This will active the emengency shutdown.">
                                        <span className="wcs_title"><HelpOutlineIcon className='wcs_tooltip_icon' /></span>
                                    </Tippy>
                                </div>

                            </div>

                            : ''}


                        <div className="error-log-btn">
                            <button className="save-webhook" onClick={handleSave}>SAVE</button>
                        </div>
                    </form>
                </div>

            </div>
            <div className="acb_right">
                <h3>
                    Emergency shutdown mode: {' '}
                    <span className={`wpnts-log ${wpntswebhook_emengency_shutdown.start_emengency_shutdown === true ? 'active' : 'inactive'}`}>
                        {wpntswebhook_emengency_shutdown.start_emengency_shutdown === true ? 'active' : 'inactive'}
                    </span>
                </h3>
                <p className="emer-info" style={{
                    fontSize: '14px',
                    lineHeight: '1.6',
                    color: '#444',
                    backgroundColor: '#f9f9f9',
                    padding: '12px',
                    borderLeft: '4px solid #ff5722',
                    borderRadius: '4px',
                    marginBottom: '15px'
                }}>
                    When the site is hacked, this tool can forcefully logout all hackers and allow <strong style={{ color: '#ff5722' }}>only super admin users</strong> to login. All other users will be forcefully logged out and automatically restricted from logging back in until emergency mode is turned off.
                </p>
                <h4>Make sure to add super admin before activating the <i>emergency shutdown:</i> <span><a target="_blank" href="https://functiondeck.com/docs/how-to-use-emengency-shutdown-panel/" style={{ color: '#0073aa', textDecoration: 'underline' }}>Guide</a></span></h4>
            </div>

            {modalOpen && <><div class="wcs_popup_overlay"></div> <Modal setOpenModal={setModalOpen} /> </>}
            <NoticeModal
                isOpen={modalConfig.isOpen}
                onClose={closeModal}
                onConfirm={modalConfig.onConfirm}
                onDecline={closeModal}
                type={modalConfig.type}
                title={modalConfig.title}
                message={modalConfig.message}
                confirmText={modalConfig.confirmText}
                declineText={modalConfig.declineText}
                position={modalConfig.position || 'center'}
                autoClose={modalConfig.type === 'toast'}
                autoCloseTime={3000}
            />
        </div >
    )
}

export default Emengency
